module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result03-9db0a25777a8a0842df67afec413ec9b.png";